package songwritersnotebook.app.di

import songwritersnotebook.app.database.SongRepository
import songwritersnotebook.app.database.ChordLibraryRepository
import songwritersnotebook.database.AppDatabase
import io.ktor.client.HttpClient
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.logging.*
import io.ktor.serialization.kotlinx.json.*
import io.ktor.client.engine.js.*
import songwritersnotebook.app.utils.PlayIntegrityService
import songwritersnotebook.app.utils.RewardedAdManager
import songwritersnotebook.app.database.DatabaseDriverFactory
import songwritersnotebook.app.utils.AudioHandler
import songwritersnotebook.app.utils.TextToSpeechHelper

actual class PlatformDependencyProvider actual constructor() {
    companion object {
        var databaseModule: DatabaseModule? = null
    }

    actual fun getSongRepository(): SongRepository? = databaseModule?.songRepository
    actual fun getChordLibraryRepository(): ChordLibraryRepository? = databaseModule?.chordLibraryRepository
    actual fun getDatabase(): AppDatabase? = databaseModule?.database
    
    private val audioHandler: AudioHandler by lazy {
        AudioHandler()
    }

    private val httpClient: HttpClient by lazy {
        println("DEBUG_DIAG: Initializing JS HttpClient...")
        HttpClient(Js) {
            install(ContentNegotiation) {
                json(kotlinx.serialization.json.Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                    encodeDefaults = true
                })
            }
            install(Logging) {
                logger = object : Logger {
                    override fun log(message: String) {
                        println("KTOR_LOG: $message")
                    }
                }
                level = LogLevel.ALL
            }
        }
    }
    
    actual fun getAudioHandler(): AudioHandler = audioHandler
    actual fun getCacheDir(): String = ""
    actual fun getHttpClient(): HttpClient = httpClient
    actual fun getPlayIntegrityService(): PlayIntegrityService? = null
    actual fun getRewardedAdManager(): RewardedAdManager? = null
    actual fun resumeAudioContext() {}
    actual fun getTextToSpeech(): TextToSpeechHelper? = null
}
